// import api from 'api';
// import storage from "storage";
import Vue from 'vue';
import DOMPurify from 'dompurify';

class helpers {
  // Preenche a variável de campos da sua view com os dados retornados do banco.
  preencherCampos(campos, valores) {
    if (!valores) return false;

    Object.entries(campos).forEach(
      (campo) => {
        if (campo[0] in valores) {
          if ('opcoes' in campos[campo[0]]) {
            // Se tiver opções, preencher corretamente para o select conseguir entender qual opção está selecionada
            Object.entries(campos[campo[0]].opcoes).some(
              (opc) => {
                let atual = Array.isArray(opc[1].valor) ? opc[1].valor.join(",") : opc[1].valor;
                let opcVal = Array.isArray(valores[campo[0]]) ? ( valores[campo[0]][0] && Object.keys(valores[campo[0]][0]).includes("valor") ? valores[campo[0]].map( item => { return item.valor } ) : valores[campo[0]].join(',') ) : valores[campo[0]];
                if (atual == opcVal || (Array.isArray(opcVal) && opcVal.includes(atual)) ){
                  if(campos[campo[0]].multi){
                    campos[campo[0]].value.push(this.copyJson(opc[1]));
                  }
                  else{
                    campos[campo[0]].value = opc[1].valor;
                    return true;
                  }
                }
              }
            );
          } else {
            if(Object.keys(campo[1]).includes("json") && campos[campo[0]].json === true){
              // Se for um campo com valores json, corrigir os campos com os dados do modelo e popular o valor corretamente
              const jsonValor = typeof valores[campo[0]] === 'object' ? valores[campo[0]] : JSON.parse(valores[campo[0]]);
              campos[campo[0]].value = jsonValor;
              let modelo = this.copyJson(campos[campo[0]].modelo);

              Object.entries(campos[campo[0]].value).forEach(
                (item) => {
                  this.deepMerge(campos[campo[0]].value[item[0]],modelo)
                }
              );

            } else {
              // Se não é só popular o valor porque é um campo normal.
              campos[campo[0]].value = valores[campo[0]];
            }
          }
        }else if(Object.keys(campo[1]).includes("json")){
          // É um campo json, então vou buscar o valor correto que veio do banco e preencher os dados.
          const nome = campos[campo[0]].json;
          const jsonValor = typeof valores[nome] === 'object' ? valores[nome] : JSON.parse(valores[nome]);
          campos[campo[0]].value = (jsonValor && jsonValor[campo[0]] && typeof jsonValor[campo[0]] !== undefined ? jsonValor[campo[0]] : []);

          let modelo = this.copyJson(campos[campo[0]].modelo);
          this.deepMerge(campos[campo[0]].value,modelo)

          Object.entries(campos[campo[0]].value).forEach(
            (item) => {
              this.deepMerge(campos[campo[0]].value[item[0]],modelo)
            }
          );
        }
      }
    );
  }
  limparVazios(obj) {
    var eu = this;
    if(typeof obj != 'object') return false;
    Object.keys(obj).forEach(function(key) {
      if (obj[key] && typeof obj[key] === 'object') eu.limparVazios(obj[key])
      else if (obj[key] == null || obj[key] == undefined) delete obj[key]
    });
  }
  deepMerge(obj1,obj2){
    var eu = this;
    if(!obj2) return {}
    Object.entries(obj2).forEach(
      (k) => {
      // Se tanto o campo no modelo quanto o valor do banco forem objetos então usar o deepMerge neles
      if (typeof obj1[k[0]] === 'object' && obj1[k[0]] && obj2[k[0]]) eu.deepMerge(obj1[k[0]],obj2[k[0]])
      // Caso contrário verificar se a chave do modelo existe no valor do campo, se não existir vou popular os dados lá
      else if(!Object.keys(obj1).includes(k[0])){
        if(typeof obj2[k[0]] === 'object'){
          // Se for um objeto, gravar como tal
          Vue.set(obj1,k[0],Object.assign({}, obj1[k[0]], obj2[k[0]]))
        } else {
          // Se for só um valor, definir.
          Vue.set(obj1,k[0],obj2[k[0]])
        }
      }
    });
  }
  preencherModelos(campos) {
    Object.entries(campos).forEach(
      (campo) => {
        if ('modelo' in campo[1] && !campo[1].value) campo[1].value = [campo[1].modelo];
      }
    );
  }
  mostrarErros(campos, retorno, app) {
    if (retorno.errors) {
      var naoEncontrados = [];
      var focou = false

      Object.entries(retorno.errors).forEach(
        ([key, value]) => {
          // Se esse item da array de erros possuir um campo, então adicionar a msg dele:
          if (key in campos) {
            if(!focou){
              // Se ainda não focou em nenhum campo, focar neste, que é o primeiro com erro
              document.querySelector('.campo_'+key).focus()
              focou = true
            }
            campos[key].error = value[0];
            if (Object.keys(campos[key]).includes('ico')) campos[key].ico = "fas fa-times text-danger";
          } else if (campos[key] !== null && typeof campos[key] === 'object' && !Object.keys(campos[key]).includes('type')) {
            Object.entries(value).forEach(([skey, svalue]) => {
              if (key in svalue) {
                campos[key][skey].error = value[0];
                if ('ico' in svalue) campos[key][skey].ico = "fas fa-times text-danger";
              }
            });
          } else naoEncontrados.push(value[0]);
        });

      if (naoEncontrados) {
        var textoErros = DOMPurify.sanitize(naoEncontrados.join("<br/>"));
        app.$notify({
          group: 'geral',
          title: 'FALHA',
          text: textoErros,
          duration: textoErros.length * 50
        });
      }
    }
    // Se retornar uma mensagem de erro:
    else if (retorno.error || retorno.message) {
      var msg = DOMPurify.sanitize(retorno.error ?? retorno.message);
      app.$notify({
        group: 'geral',
        title: 'FALHA',
        text: msg,
        duration: msg.length * 50
      });
    } else {
      app.$notify({
        group: 'geral',
        title: 'Erro desconhecido',
        text: 'Algo muito estranho ocorreu, contate a equipe de suporte.',
        duration: 3000
      });
    }
  }
  dadosParaSalvar(campos) {
    var objSalvar = {};
    Object.entries(campos).forEach(([key, value]) => {
      if ('value' in value) {
        // Tratar os dados, caso necessário:
        var valor = null;
        if ('opcoes' in value) valor = (value.value && typeof value.value === 'object' && Object.keys(value.value).includes('valor')) ? value.value.valor : value.value;
        else valor = value.value;

        if ('json' in value) {
          if (value.json === true) {
            objSalvar[key] = JSON.stringify(valor);
          } else {
            // Se foi setado para salvar como json, definir o json
            let atual = objSalvar[value.json] ? JSON.parse(objSalvar[value.json]) : {};
            // Remover todas as definições antes de converter em json
            if (typeof valor === 'object') {
              Object.entries(valor).forEach(([vk, vv]) => {
                if (vv[1] && typeof vv[1] === 'object' && Object.keys(vv[1]).includes('_defs')) delete valor[vk]._defs;
              });
            }

            atual[key] = valor;

            valor = JSON.stringify(atual);
            key = value.json;
            objSalvar[key] = valor;
          }
        } else if (!('json' in value)) objSalvar[key] = valor;
      }
    });
    return objSalvar;
  }
  copyJson(json){
    return json ? JSON.parse(JSON.stringify(json)) : json
  }
  camelCase(str){
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }
}
export default new helpers();